<template>
  <div>
    <div v-if="userReport">
      <reportUserMonth
        :domain="domain"
        :settings="settings"
        :selectGroup="selectGroup"
        :assigned="1"
        @userReport="userReportBack"
      />
    </div>
    <div v-else>
      <div class="manager-panel">
        <a-row type="flex" justify="space-between" align="middle">
          <a-col style="flex: 1;">
            <a-dropdown v-model="seachMenuView" :trigger="['click']">
              <a-input-search class="ant-dropdown-link" placeholder="Search" :value="sortActive" />
              <a-menu slot="overlay" style="background-color:#fafafa">
                <a-form id="my_form_search_styl" layout="vertical" style="padding:15px">
                  <a-menu-item key="1">
                    <a-form-item
                      label="Specjalista PPC"
                      :label-col="{span:8}"
                      :wrapper-col="{span:8}"
                    >
                      <a-select
                        v-model="sort.specjalista"
                        style="width: 170px"
                        show-search
                        placeholder="Select"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                      >
                        <a-select-option
                          v-for="user in selectAssignedList"
                          :value="user.id"
                          :key="user.id"
                        >{{user.name}}</a-select-option>
                      </a-select>
                      <a-icon
                        style="margin-left: 5px"
                        @click="el => clearSelect('specjalista')"
                        type="delete"
                      />
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="2">
                    <a-form-item label :label-col="{span:8}" :wrapper-col="{span:8}"></a-form-item>
                  </a-menu-item>
                  <a-form-item
                    style="text-align:center;"
                    :label-col="{span:0}"
                    :wrapper-col="{span:24}"
                  >
                    <a-button type="primary" @click="updataReportMediaList">{{ $t('Search') }}</a-button>
                  </a-form-item>
                </a-form>
              </a-menu>
            </a-dropdown>
          </a-col>
        </a-row>
      </div>
      <a-table :columns="columnsReportMediaList" :data-source="reportMediaList" bordered>
        <template slot="nazwa" slot-scope="text, record">
          <a @click="() => {reportUserActive(record)}">{{text}}</a>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getMediaListForecastsSort } from "@/requestFunc";
import reportUserMonth from "./reportUserMonth";
import moment from "moment";
export default {
  name: "reportMediaList",
  props: ["settings", "user_setup", "USER_ACTIVE", "domain"],
  components: {
    reportUserMonth,
  },
  data() {
    return {
      columnsReportMediaList: [
        {
          title: "Nazwa",
          dataIndex: "title",
          scopedSlots: { customRender: "nazwa" },
          width: 300,
        },
        {
          title: "Stan",
          dataIndex: "stan",
          scopedSlots: { customRender: "stan" },
          width: 140,
        },
        {
          title: this.$t("Master Obligation"),
          dataIndex: "oblektNadrzedny",
          scopedSlots: { customRender: "oblektNadrzedny" },
          width: 120,
        },
        {
          title: this.$t("CompanyName"),
          dataIndex: "spolka",
          scopedSlots: { customRender: "spolka" },
          width: 90,
        },
        {
          title: "Opis",
          dataIndex: "opis",
          scopedSlots: { customRender: "opis" },
          width: 120,
        },
        {
          title: this.$t("Created"),
          dataIndex: "utworzyl",
          scopedSlots: { customRender: "utworzyl" },
          width: 120,
        },
        {
          title: this.$t("Created date"),
          dataIndex: "utworzano",
          scopedSlots: { customRender: "utworzano" },
          width: 110,
        },
      ],
      sort: {
        specjalista: "",
      },
      selectAssignedList: [],
      reportMediaList: [],
      userReport: false,
      selectGroup: {},
      seachMenuView: false,
      statusEdit: false,
      sortActive: "",
    }
  },
  methods: {
    getSelectUserList: function () {
      return this.settings.data_user.map((user) => ({
        id: user.ID,
        name: user.LAST_NAME + " " + user.NAME,
      }));
    },
    searchUser: function (idUser) {
      let user = this.settings.data_user.find((user) => {
        return user.ID == idUser;
      });
      return user ? user.LAST_NAME + " " + user.NAME : "";
    },
    getMount: function (data) {
      return moment(data, "MM").format("MMMM");
    },
    selectAssignedListUpdate: function () {
      this.selectAssignedList = this.user_setup.mediaAssigned.map((idUser) => {
        let user = this.settings.data_user.find((el) => el.ID == idUser);
        return {
          id: user.ID,
          name: user.LAST_NAME + " " + user.NAME,
        };
      });
    },
    updataReportMediaList: function () {
      let sort = {};
      for (let key in this.sort) {
        if (this.sort[key] != "") {
          if (key == "specjalista") {
            sort.specjalista = this.sort[key];
          }
        }
      }
      this.sortActive = this.setSortActive(sort);


      getMediaListForecastsSort(sort)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);

          this.reportMediaList = [];
          let assignedList = [];

          for (let i in item.project) {
            for (let j in item.project[i].info) {
              let mediaList = assignedList.find(
                (el) =>
                  el.ASSIGNED_BY_ID == item.project[i].info[j].ASSIGNED_BY_ID
              );
              if (!mediaList) {
                assignedList.push({
                  ASSIGNED_BY_ID: item.project[i].info[j].ASSIGNED_BY_ID,
                  date: [
                    {
                      month: item.project[i].info[j].month,
                      year: item.project[i].info[j].year,
                    },
                  ],
                });
              } else {
                if (
                  !mediaList.date.find(
                    (el) =>
                      el.month == item.project[i].info[j].month &&
                      el.year == item.project[i].info[j].year
                  )
                ) {
                  mediaList.date.push({
                    month: item.project[i].info[j].month,
                    year: item.project[i].info[j].year,
                  });
                }
              }
            }
          }

          let key = 0;
          for (let i in assignedList) {
            let assigned = this.searchUser(assignedList[i].ASSIGNED_BY_ID);
            assignedList[i].date.sort((a, b) => {
              return Number(a.year) * 100 + Number(a.month) >
                Number(b.year) * 100 + Number(b.month)
                ? 1
                : -1;
            });
            for (let m in assignedList[i].date) {
              this.reportMediaList.push({
                key,
                title:
                  assigned +
                  ", " +
                  this.getMount(assignedList[i].date[m].month) +
                  ", " +
                  assignedList[i].date[m].year,
                ASSIGNED_BY_ID: assignedList[i].ASSIGNED_BY_ID,
                month: assignedList[i].date[m].month,
                year: assignedList[i].date[m].year,
              });
              key++;
            }
          }
          this.seachMenuView = false;
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },

    setSortActive(sort) {
      let sortActive = "";
      if (sort.specjalista != "") {
        sortActive = this.searchUser(sort.specjalista);
      }
      return sortActive;
    },

    reportUserActive: function (record) {
      this.selectGroup = record;
      this.userReport = true;
    },
    userReportBack: function () {
      this.userReport = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    clearSelect: function (nameSelect) {
      this.sort[nameSelect] = "";
    },
    changeStatusEdit: function () {
      let userEditActive = [...this.user_setup.mediaResponsible].concat([
        ...this.user_setup.mediaAssigned,
      ]);
      this.statusEdit = Boolean(
        userEditActive.find((el) => el == this.USER_ACTIVE.ID)
      );
    },
  },
  mounted() {
    this.changeStatusEdit();

    if (this.statusEdit) {
      this.sort.specjalista = this.USER_ACTIVE.ID;
    }
    this.updataReportMediaList();
    this.selectAssignedListUpdate();
    BX24.fitWindow();
  },
};
</script>

<style scoped>
.manager-panel {
  margin: 10px 0;
}
</style>
